import { render, staticRenderFns } from "./TimelineEditor.vue?vue&type=template&id=b45699f8&scoped=true&"
import script from "./TimelineEditor.vue?vue&type=script&lang=js&"
export * from "./TimelineEditor.vue?vue&type=script&lang=js&"
import style0 from "./TimelineEditor.vue?vue&type=style&index=0&id=b45699f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45699f8",
  null
  
)

export default component.exports